export const quickDateOptions = [
  { label: "今天", value: "today", startOffset: 0, endOffset: 0 },
  { label: "昨天", value: "yesterday", startOffset: 1, endOffset: 1 },
  { label: "最近2天", value: "last_2_days", startOffset: 1, endOffset: 0 },
  { label: "最近3天", value: "last_3_days", startOffset: 2, endOffset: 0 },
  { label: "最近5天", value: "last_5_days", startOffset: 4, endOffset: 0 },
  { label: "最近7天", value: "last_7_days", startOffset: 6, endOffset: 0 },
  { label: "最近30天", value: "last_30_days", startOffset: 29, endOffset: 0 },
];

const getDaysAgoDate = (days) => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() - days);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

export const getQuickRange = (value) => {
  const option = quickDateOptions.find((item) => item.value === value);
  return option ? { startDate: getDaysAgoDate(option.startOffset), endDate: getDaysAgoDate(option.endOffset) } : null;
};

export const formatRecordRange = (range, emptyLabel = "全部记录") => {
  if (!range.startDate && !range.endDate) return emptyLabel;
  if (!range.startDate) return `截至 ${range.endDate}`;
  if (!range.endDate) return `${range.startDate} 起`;
  return range.startDate === range.endDate ? range.startDate : `${range.startDate} 至 ${range.endDate}`;
};

const dateTimestamp = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ""))) return NaN;
  const timestamp = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === value ? timestamp : NaN;
};

export const getDateRangeError = (range, allowOpenRange = false) => {
  const hasStart = Boolean(range.startDate);
  const hasEnd = Boolean(range.endDate);
  const start = dateTimestamp(range.startDate);
  const end = dateTimestamp(range.endDate);
  if ((!allowOpenRange && (!hasStart || !hasEnd)) || (hasStart && !Number.isFinite(start)) || (hasEnd && !Number.isFinite(end))) {
    return allowOpenRange ? "请选择有效的日期，或清空日期查询" : "请选择完整、有效的开始和结束日期";
  }
  if (hasStart && hasEnd && start > end) return "开始日期不能晚于结束日期";
  if (!allowOpenRange && (end - start) / 86400000 + 1 > 366) return "日期范围最多支持 366 天";
  return "";
};
